import { useEffect } from "react";

const SITE = "La Fondation des Artistes Handicapées de France";
const ORIGIN = "https://lesartisteshandicap.fr";
const DEFAULT_OG = `${ORIGIN}/og-image.jpg`;

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export const Seo = ({ title, description, image, path = "", jsonLd }) => {
  useEffect(() => {
    const fullTitle = title ? `${title} · ${SITE}` : SITE;
    const desc =
      description ||
      "Galerie et boutique d'art d'artistes handicapés de France. Œuvres expressionnistes uniques. Chaque tableau acheté soutient directement son créateur.";
    const img = image || DEFAULT_OG;
    const url = `${ORIGIN}${path}`;

    document.title = fullTitle;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:image", img);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", SITE);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", desc);
    setMeta("name", "twitter:image", img);
    setCanonical(url);

    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => {
      if (script) document.head.removeChild(script);
    };
  }, [title, description, image, path, jsonLd]);

  return null;
};
